import { render, staticRenderFns } from "./TableTags.vue?vue&type=template&id=1d9c86dd&scoped=true&"
import script from "./TableTags.vue?vue&type=script&lang=js&"
export * from "./TableTags.vue?vue&type=script&lang=js&"
import style0 from "./TableTags.vue?vue&type=style&index=0&id=1d9c86dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9c86dd",
  null
  
)

export default component.exports